import { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  Box,
} from "@mui/material";
import axios from "axios";
import { Link } from "react-router-dom";

const AdminBlogs = () => {
  const [journals, setJournals] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [page, setPage] = useState(1); // Sayfa numarası durumu
  const [rowsPerPage, setRowsPerPage] = useState(5); // Her sayfada gösterilecek satır sayısı

  useEffect(() => {
    axios
      .get("https://kariyer.biyomed.net/api/admin/getAllBlogs", {
        withCredentials: true,
      })
      .then((response) => setJournals(response.data))
      .catch((error) => console.error("Veri çekme hatası:", error));
  }, []);
  

  const handleDelete = (id) => {
    if (window.confirm("Bu journal'i silmek istediğinizden emin misiniz?")) {
      axios
        .delete(`https://kariyer.biyomed.net/api/journal/delete-journal/${id}`)
        .then(() =>
          setJournals(journals.filter((journal) => journal.id !== id))
        )
        .catch((error) => console.error("Silme hatası:", error));
        alert("Başarıyla Silindi")
    }
  };

  // Tarih filtrelemesi
  const filteredJournals = journals.filter((journal) => {
    const journalDate = new Date(journal.created_at).toLocaleDateString(
      "en-CA"
    ); // 'yyyy-mm-dd' formatında
    const isTitleMatch = journal.title?.toLowerCase()
      .includes(searchTitle?.toLowerCase());
    const isDateMatch = searchDate ? journalDate === searchDate : true; // Tarih eşleşmesi
    return isTitleMatch && isDateMatch;
  });

  // Journals'ı oluşturulma tarihine göre en yeniye göre sıralama
  const sortedJournals = filteredJournals.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });

  // Sayfa numarası değiştiğinde, sayfa numarasını güncelleme
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Sayfa verilerini belirleyelim
  const indexOfLastPost = page * rowsPerPage;
  const indexOfFirstPost = indexOfLastPost - rowsPerPage;
  const currentJournals = sortedJournals.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {/* Başlık arama */}
      <TextField
        label="Başlığa Göre Ara"
        variant="outlined"
        value={searchTitle}
        onChange={(e) => setSearchTitle(e.target.value)}
        sx={{ mr: 2, mb: 2 }}
      />
      {/* Tarih arama */}
      <TextField
        type="date"
        variant="outlined"
        value={searchDate}
        onChange={(e) => setSearchDate(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Başlık</TableCell>
              <TableCell>Oluşturulma Tarihi</TableCell>
              <TableCell>SinglePage Linki (Tek sayfa linki)</TableCell>
              <TableCell >İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentJournals.map((journal) => (
              <TableRow key={journal.id}>
                <TableCell>{journal.id}</TableCell>
                <TableCell>{journal.title}</TableCell>
                <TableCell>
                  {new Date(journal.created_at).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <a
                    href={`https://bulten.biyomed.net/bulten/${journal.title}-${journal.id}`}
                  >
                    https://bulten.biyomed.net/bulten/{journal.title}-
                    {journal.id}
                  </a>
                </TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Link to={`/admin/update-journal/${journal.id}`}>
                      <Button variant="contained" color="primary">
                        Güncelle
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => handleDelete(journal.id)}
                    >
                      Sil
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Pagination
        count={Math.ceil(filteredJournals.length / rowsPerPage)} // Toplam sayfa sayısı
        page={page} // Mevcut sayfa
        onChange={handlePageChange} // Sayfa değiştirme fonksiyonu
        color="primary"
        sx={{ mt: 3, display: "flex", justifyContent: "center" }}
      />
    </Container>
  );
};

export default AdminBlogs;
